import { HRISContent } from "./HRISPageContent";
import { restUseCase } from "../usecases/rest";
import { dialog } from "nq-component";

class HRISPresenter {
  constructor(view) {
    this.view = view;
  }

  componentDidMount() {}
  getHeroSectionContent() {
    return HRISContent.heroContent;
  }

  getFooterContent() {
    return HRISContent.footerContent;
  }

  getOverviewCards() {
    return HRISContent.overviewCards;
  }

  getFutureCards() {
    return HRISContent.futureCards;
  }

  getSystemCapabilities() {
    return HRISContent.systemCapabilities;
  }

  getKeySystemModules() {
    return HRISContent.keySystemModules;
  }

  getComplianceItems() {
    return HRISContent.complianceItems;
  }

  getDashboardImage() {
    return HRISContent.dashboardImage;
  }

  async submit(formData) {
    const method = "POST";
    const path = "/send-email/bfa1d64a-79d5-40b0-af03-4a7a781b0c97";

   const obj = {
  to: formData.email,
  subject: `Demo Inquiry - ${formData.company}`,
  body: `
    Hi <strong>${formData.firstName}</strong>,<br><br>

    Thanks for requesting a demo of <strong><em>Human Resource Information Technology</em></strong> — we’re excited to connect with you!<br><br>

    <strong>Here’s a quick summary of your request:</strong><br>
    - Name: ${formData.firstName} ${formData.lastName}<br>
    - Company: ${formData.company}<br>
    - Business Email: ${formData.email}<br>
    - Phone Number: ${formData.contactNumber}<br>
    - Employee Size: ${formData.employeeSize}<br>

    🕒 <strong>What’s Next?</strong><br>
    Our team will review your request and reach out shortly to coordinate the schedule that works best for you. You’ll receive a separate email once your demo is officially booked.<br><br>

    If you have any questions in the meantime, feel free to reply to this email or contact us.<br><br>

    Thanks again for your interest!<br><br>

    Best regards,<br>
    <strong>Tenth Corporation Team</strong>
  `
};


    console.log("Submitted via presenter:", formData);

    try {
      dialog.fire({
        html: (
          <div className="text-center py-4">
            <i className="bi bi-send fs-1 text-primary mb-3"></i>
            <h5 className="mb-2">Sending Message</h5>
            <p>Please wait while we send your message...</p>
          </div>
        ),
        footer: false,
      });

      const response = await restUseCase().execute(method, path, { body: obj });

      if (response) {
        this.view.closeDialog();
        this.view.showSuccess(
          "Your message has been sent successfully!",
          "Success"
        );
      }
    } catch (error) {
      this.view.closeDialog();
      this.view.showDialog({
        title: "Failed",
        message:
          "Something went wrong while sending your message. Please try again.",
        icon: "bi bi-x-circle",
        type: "danger",
        positiveButton: "OKAY",
      });
    }
  }

  onChange(value, field) {
    try {
      let sanitizedValue = value;

      if (field === "contactNumber") {
        sanitizedValue = value.replace(/\D/g, "").slice(0, 12);
      }

      const updated = {
        ...this.view.state.formData,
        [field]: sanitizedValue,
      };

      this.view.setState({ formData: updated });
    } catch (error) {
      console.error(`Error updating form field "${field}":`, error);
    }
  }
}

export default HRISPresenter;
